module.exports = __webpack_public_path__ + "static/media/privacy.7b242a78.png";